export class QuickLinks
{
    title:string;
    logo:string;
    url:string;
}